import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import $ from "jquery";
import { loader_image } from "../_components/Imagepath";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';

const SupplierssituationDetails = () => {

  let { id } = useParams();


  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  const [overviewdata, setOverviewdata] = useState({});

  const [systemdetails, setSystemdetails] = useState({});


  const [datacreditnotes, setDatacreditnotes] = useState([]);
  const [datapayemnts, setDatapayemnts] = useState([]);


  let season_id = localStorage.getItem("season_id");

  const [formData, setFormData] = useState({
    id: id,
    season_id: season_id,
    start_date: '',
    end_date: ''
  });

  useEffect(() => {
    if (id) {
      setFormData((prev) => ({
        ...prev,
        id: id
      }));
    }
  }, [id]);
  // useEffect(() => {
  //   setPermission(FindModuleById(457));
  //   console.log(permission); console.log(formData);
  //   axios.post(`/finance-supplier-situation/details`, formData, {
  //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //   }).then((response) => {
  //     if (response.data.code === 200) {
  //       setData(response.data.data.invoices);
  //       setDatacreditnotes(response.data.data.credit_notes);
  //       setDatapayemnts(response.data.data.payments);
  //       setOverviewdata(response.data.data.overview);
  //       setSystemdetails(response.data.data.supplier_detail);

  //     }
  //   })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, []);
  useEffect(() => {
  setPermission(FindModuleById(457));
   console.log(permission);
  axios.post(`/finance-supplier-situation/details`, formData, {
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  }).then((response) => {
    if (response.data.code === 200) {
      setData(response.data.data.invoices);
      setDatacreditnotes(response.data.data.credit_notes);
      setDatapayemnts(response.data.data.payments);
      setOverviewdata(response.data.data.overview);
      setSystemdetails(response.data.data.supplier_detail);
      
      // Update formData with dates from response if they exist
      if (response.data.data.start_date && response.data.data.end_date) {
        setFormData(prev => ({
          ...prev,
          start_date: response.data.data.start_date,
          end_date: response.data.data.end_date
        }));
      }
    }
  })
  .catch((error) => {
    console.log(error);
  });
}, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  console.log(formData);
  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(`/finance-supplier-situation/details`, formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },

      })
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.invoices);
          setDatacreditnotes(response.data.data.credit_notes);
          setDatapayemnts(response.data.data.payments);
          setOverviewdata(response.data.data.overview);

          setSystemdetails(response.data.data.supplier_detail);
          // Update formData with dates from response if they exist
          if (response.data.data.start_date && response.data.data.end_date) {
            setFormData(prev => ({
              ...prev,
              start_date: response.data.data.start_date,
              end_date: response.data.data.end_date
            }));
          }
          

        } else {
          // setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });



  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



  const InvoiceNumberCell = ({ row }) => (
   <a href={`/expenses-view/${row.original.id}`} className="btn btn-link">
        {row.original.invoice_number}
      </a>
  );
 

  InvoiceNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        invoice_number: PropTypes.string.isRequired,
      }),
    }).isRequired,
  };


  const DueDateCell = ({ row }) => {
    const dueDate = row.original.invoice_due_date;
    if (!dueDate) return '';



    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const due = new Date(dueDate);
    due.setHours(0, 0, 0, 0);

    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Show in red if due date is in the FUTURE and within next 7 days
    // diffDays > 0 means future date, diffDays <= 7 means within 7 days
    const isUrgent = diffDays <= 7;

    return (
      <span style={{ color: isUrgent ? 'red' : 'inherit', fontWeight: isUrgent ? 'bold' : 'normal' }}>
        {dueDate}
      </span>
    );
  };

  DueDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        invoice_due_date: PropTypes.string,
        payment_status: PropTypes.string,

      }),
    }).isRequired,
  };


  const TVARateCell = ({ row }) => {
    const items = row.original.items;

    // Collect all unique TVA rates using a Set
    const tvaRates = new Set();

    // Extract TVA rates from items array if it exists
    if (items && Array.isArray(items)) {
      items.forEach(item => {
        if (item.tva_rate !== undefined && item.tva_rate !== null && item.tva_rate !== '') {
          tvaRates.add(item.tva_rate);
        }
       
      });
    }

    // Convert Set to array, sort, and join with '|'
    const tvaRatesDisplay = Array.from(tvaRates)
      .sort((a, b) => Number(a) - Number(b))
      .join(' | ');

    return <span>{tvaRatesDisplay || '-'}</span>;
  };

  TVARateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.array, // Changed from PropTypes.string to PropTypes.array
      }),
    }).isRequired,
  };

  const TVAAmount = ({ row }) => {
    const items = row.original.items;

    // Collect all unique TVA rates using a Set
    const tvaRates = new Set();

    // Extract TVA rates from items array if it exists
    if (items && Array.isArray(items)) {
      items.forEach(item => {
        if (item.tva_amount !== undefined && item.tva_amount !== null && item.tva_amount !== '') {
          tvaRates.add(item.tva_amount);
        }
       
      });
    }

    // Convert Set to array, sort, and join with '|'
    const tvaRatesDisplay = Array.from(tvaRates)
      .sort((a, b) => Number(a) - Number(b))
      .join(' | ');

    return <span>{tvaRatesDisplay || '-'}</span>;
  };

  TVAAmount.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.array, // Changed from PropTypes.string to PropTypes.array
      }),
    }).isRequired,
  };


  
  const PaymentStatusCell = ({ row }) => {
    const paymentStatus = row.original.payment_status;
    if (!paymentStatus) return '';

    const isPaid = paymentStatus.toUpperCase() === 'PAID';

    return (
      <span style={{
        color: isPaid ? 'green' : 'inherit',
        fontWeight: isPaid ? 'bold' : 'normal'
      }}>
        {paymentStatus}
      </span>
    );
  };

  PaymentStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        payment_status: PropTypes.string,
      }),
    }).isRequired,
  };

  const columns =
    [

      {
        header: "Invoice Number",
        Cell: InvoiceNumberCell,
      },


      {
        accessorKey: 'invoice_date',
        header: 'Invoice Date',
      },


      {
        accessorKey: 'invoice_due_date',
        header: 'Due Date',
        Cell: DueDateCell,
      },
      {
        accessorKey: 'amount_ht',
        header: 'Amount HT',
      },
      {
        accessorKey: 'tva_rate',
        header: 'TVA Rate',
        Cell: TVARateCell,
      },
       {
        accessorKey: 'tva_amount',
        header: 'TVA Amount',
        Cell: TVAAmount,
      },
      // {
      //   accessorKey: 'tva_amount',
      //   header: 'TVA Amount',
      // },
      {
        accessorKey: 'total_amount',
        header: 'Total Amount TTC',
      },
    ];


  const columns_payemnts =
    [
      {
        accessorKey: 'payment_date',
        header: 'Payment Date',
      },
      {
        accessorKey: 'payment_method',
        header: 'Payment Method',
      },
      {
        accessorKey: 'total_amount',
        header: 'Amount Of Invoice',
      },


      {
        accessorKey: 'payment_note',
        header: 'Payment Note',
      },


    ];

  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }

  const downloadExcel = (e) => {
    console.log(e);
    const queryString = objectToQueryString(formData);

    $("#loader-image2").removeClass('loader-hide2');
    $("#loader-image2").addClass('loader-show2');
    window.open(`${base_url}/finance-supplier-situation/details-excel?${queryString}`, '_blank');
    $("#loader-image2").addClass('loader-hide2');
    $("#loader-image2").removeClass('loader-show2');
  }

  const downloadPDF = (e) => {
    console.log(e);
    $("#loader-image").removeClass('loader-hide').addClass('loader-show');
    let season_id = localStorage.getItem("season_id");
    axios.get("/finance-supplier-situation/details-pdf", {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      params: { season_id: season_id, id: formData.id, start_date: formData.start_date, end_date: formData.end_date }
    })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let supp_name = systemdetails.name ? systemdetails.name : "";
        let startdate = systemdetails.start_date ? systemdetails.start_date : "";
        let endate = systemdetails.end_date ? systemdetails.end_date : "";

        link.download = supp_name + ' - ' + startdate + ' - ' + endate + '.pdf';
        link.click();

        $("#loader-image").removeClass('loader-show').addClass('loader-hide');
      })
      .catch(error => {
        console.error('Error downloading PDF:', error);
        $("#loader-image").removeClass('loader-show').addClass('loader-hide');
      });
  };
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title"> Suppliers Situation Details</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Suppliers Situation Details</li>
                </ul>
              </div>

            </div>
          </div>


          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <th className="p-3">Supplier Name</th>
                        <td className="p-3">{systemdetails.name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">IF</th>
                        <td className="p-3">{systemdetails.if}</td>
                      </tr>
                      <tr>
                        <th className="p-3">ICE</th>
                        <td className="p-3">{systemdetails.ice}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Expense Type</th>
                        <td className="p-3">{systemdetails.expense_type}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div id="filter_inputs_div" className="card filter-card1">
            <div className="card-body p-10">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Start Date:</label>

                      <input type="hidden" name="supplier" className="form-control" value={formData.id} />

                      <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mt-2">
                                            &nbsp;&nbsp;

                      <button style={{ float: 'right', marginLeft:"5px" }}
                        className="btn btn-primary"
                        onClick={() => downloadPDF()}
                      >
                        <i className="fas fa-file-pdf font-24" ></i>  <img id="loader-image" className="loader-image loader-hide" src={loader_image} />
                      </button>
                      &nbsp;&nbsp;
                      <button style={{ float: 'right' }}
                        className="btn btn-primary"
                        onClick={() => downloadExcel()}
                      >
                        <i className="fas fa-file-excel	font-24"></i> <img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image} />
                      </button>
                    &nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>

          <div className="row" >

            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
              <div className="card inovices-card w-100">
                <div className="card-body">
                  <div className="dash-widget-header">
                    <div className="dash-count text-center">
                      <div className="dash-title"> Total Amount</div>
                      <div className="dash-counts">
                        <p>{overviewdata.total_amount}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
              <div className="card inovices-card w-100">
                <div className="card-body">
                  <div className="dash-widget-header">
                    <div className="dash-count text-center">
                      <div className="dash-title"> Paid Amount </div>
                      <div className="dash-counts">
                        <p>{overviewdata.paid_amount}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
              <div className="card inovices-card w-100">
                <div className="card-body">
                  <div className="dash-widget-header">
                    <div className="dash-count text-center">
                      <div className="dash-title"> Open amount  </div>
                      <div className="dash-counts">
                        <p>{overviewdata.open_amount}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
              <div className="card inovices-card w-100">
                <div className="card-body">
                  <div className="dash-widget-header">
                    <div className="dash-count text-center">
                      <div className="dash-title"> Total Credit Notes  </div>
                      <div className="dash-counts">
                        <p>{overviewdata.credit_note}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-sm-12">


              <section className="comp-section">
                <div className="row">

                  <div className="col-md-12">

                    <div className="card bg-white">

                      <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">

                          <li className="nav-item">
                            <a className="nav-link active" href="#listing-groupby" data-bs-toggle="tab"> Invoices</a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> Payments</a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#listing-credit-note" data-bs-toggle="tab"> Credit Note</a>
                          </li>

                        </ul>
                        <div className="tab-content">
                          <div className="tab-pane show active" id="listing-groupby">
                            <div className="row" id="listing-followup-groupby" >
                              <div className="col-sm-12" >
                                <div className="card card-table">
                                  <div className="card-body">
                                    <div className="table-responsive">

                                      <MaterialReactTable
                                        columns={columns}
                                        data={data}
                                        enableColumnOrdering
                                        enablePinning
                                      />

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="tab-pane " id="listing-all">
                            <div className="row" id="listing-followup">
                              <div className="col-sm-12">
                                <div className="card card-table">
                                  <div className="card-body">
                                    <div className="table-responsive">

                                      <MaterialReactTable
                                        columns={columns_payemnts}
                                        data={datapayemnts}
                                        enableColumnOrdering
                                        enablePinning
                                      />

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="tab-pane " id="listing-credit-note">
                            <div className="row" id="listing-followup">
                              <div className="col-sm-12">
                                <div className="card card-table">
                                  <div className="card-body">
                                    <div className="table-responsive">
                                      <MaterialReactTable
                                        columns={columns}
                                        data={datacreditnotes}
                                        enableColumnOrdering
                                        enablePinning
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupplierssituationDetails;
